/*
 * Ripple button, ported from Animate UI (https://animate-ui.com), MIT + Commons Clause,
 * Copyright (c) 2025 Elliot Sutton. See THIRD_PARTY_NOTICES.md.
 */
import { forwardRef, useCallback, useRef, useState } from "react";
import { motion } from "framer-motion";

const RippleButton = forwardRef(function RippleButton({ onClick, children, className = "", rippleColor = "rgba(255,255,255,0.55)", style, ...props }, _ref) {
  const [ripples, setRipples] = useState([]);
  const btn = useRef(null);
  const handle = useCallback((e) => {
    const r = btn.current?.getBoundingClientRect();
    if (r) {
      const ripple = { id: Date.now() + Math.random(), x: e.clientX - r.left, y: e.clientY - r.top };
      setRipples((p) => [...p, ripple]);
      setTimeout(() => setRipples((p) => p.filter((x) => x.id !== ripple.id)), 600);
    }
    onClick?.(e);
  }, [onClick]);
  return (
    <motion.button
      ref={btn}
      onClick={handle}
      whileTap={{ scale: 0.96 }}
      whileHover={{ scale: 1.02 }}
      className={className}
      style={{ position: "relative", overflow: "hidden", ...style }}
      {...props}
    >
      {ripples.map((r) => (
        <motion.span
          key={r.id}
          aria-hidden="true"
          initial={{ scale: 0, opacity: 0.5 }}
          animate={{ scale: 12, opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          style={{ position: "absolute", borderRadius: "50%", pointerEvents: "none", width: 20, height: 20, top: r.y - 10, left: r.x - 10, backgroundColor: rippleColor }}
        />
      ))}
      <span className="relative inline-flex items-center justify-center gap-2">{children}</span>
    </motion.button>
  );
});
export default RippleButton;
